import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/ui/Header";
import HeroSection from "./components/HeroSection";
import ImpactDashboard from "./components/ImpactDashboard";
import ValuesSection from "./components/ValuesSection";
import LogoSolarValley from "../../components/img/SolarValley.svg";
import { useConfig } from "../../context/ConfigContext";

const AboutSolarValley = () => {
  const config = useConfig();
  const { COMPANY_NAME, PHONE_NUMBER_FORM, EMAIL_ADDRESS } = config;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Acerca de {COMPANY_NAME} - Pioneros en Energía Solar Guatemala
        </title>
        <meta
          name="description"
          content={`Conoce la historia, valores y visión de ${COMPANY_NAME}. Líderes en energía solar en Guatemala desde 2018, transformando el futuro energético del país con tecnología de vanguardia y compromiso ambiental.`}
        />
        <meta
          name="keywords"
          content={`${COMPANY_NAME} Guatemala, empresa solar, energía renovable, Paneles Solares Guatemala, Limpieza Solar, Termografía Solar, expertos energía solar`}
        />
        <link rel="canonical" href="https://www.solarvalleygt.com/nosotros" />
        <meta
          property="og:title"
          content={`Acerca de ${COMPANY_NAME} - Pioneros en Energía Solar Guatemala`}
        />
        <meta
          property="og:description"
          content={`Descubre cómo ${COMPANY_NAME} está transformando Guatemala con energía solar limpia y sostenible. Conoce nuestro equipo, valores y compromiso con el futuro energético del país.`}
        />
        <meta property="og:image" content="/og-image.png" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-16">
          <HeroSection />
          {<ImpactDashboard />}
          <ValuesSection />
        </main>

        {/* Footer */}
        <footer className="bg-text-primary text-white py-12">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <img src={LogoSolarValley} alt="Logo" width="100" />
                  <div>
                    <h3 className="font-bold">{COMPANY_NAME}</h3>
                    <p className="text-sm text-white/80">
                      Energía Limpia Guatemala
                    </p>
                  </div>
                </div>
                <p className="text-white/80 text-sm">
                  Transformando Guatemala a través de la energía solar limpia y
                  sostenible.
                </p>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-semibold mb-4">Enlaces Rápidos</h4>
                <div className="space-y-2 text-sm">
                  <Link
                    to="/homer"
                    className="block text-white/80 hover:text-white solar-transition"
                  >
                    Inicio
                  </Link>
                  <Link
                    to="/calculadora"
                    className="block text-white/80 hover:text-white solar-transition"
                  >
                    Calculadora Solar
                  </Link>
                  <Link
                    to="/proyectos"
                    className="block text-white/80 hover:text-white solar-transition"
                  >
                    Nuestros Proyectos
                  </Link>
                  <Link
                    to="/servicios"
                    className="block text-white/80 hover:text-white solar-transition"
                  >
                    Servicios
                  </Link>
                </div>
              </div>

              {/* Contact */}
              <div>
                <h4 className="font-semibold mb-4">Contacto</h4>
                <div className="space-y-2 text-sm text-white/80">
                  <p>📧 {EMAIL_ADDRESS}</p>
                  <p>📞 {PHONE_NUMBER_FORM}</p>
                  <p>📍 Ciudad de Guatemala</p>
                </div>
              </div>

              {/* Social */}
              {/*<div>
                <h4 className="font-semibold mb-4">Síguenos</h4>
                <div className="flex space-x-3">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center hover:bg-primary solar-transition cursor-pointer">
                    <span className="text-xs">f</span>
                  </div>
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center hover:bg-primary solar-transition cursor-pointer">
                    <span className="text-xs">ig</span>
                  </div>
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center hover:bg-primary solar-transition cursor-pointer">
                    <span className="text-xs">in</span>
                  </div>
                </div>
              </div>*/}
            </div>

            <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-white/80">
              <p>
                &copy; {new Date()?.getFullYear()} {COMPANY_NAME} Guatemala.
                Todos los derechos reservados.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AboutSolarValley;
